import { initState, setSearchOpen } from './state';
import { initRouter } from './ui/router';
import { initSearchModal } from './ui/search-modal';

function showError(err: unknown): void {
  const app = document.getElementById('app');
  const msg = err instanceof Error ? `${err.name}: ${err.message}\n\n${err.stack ?? ''}` : String(err);
  const div = document.createElement('pre');
  div.style.cssText = 'padding:24px;color:#c00;font-size:13px;white-space:pre-wrap;font-family:monospace';
  div.textContent = `App startup error:\n${msg}`;
  if (app) { app.innerHTML = ''; app.appendChild(div); }
  else document.body.appendChild(div);
}

window.addEventListener('unhandledrejection', (e) => {
  showError(e.reason);
});

function main(): void {
  initState();

  const app = document.getElementById('app');
  if (!app) {
    throw new Error('Missing root element #app');
  }

  initRouter(app);
  initSearchModal(document.body);

  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      setSearchOpen(true);
    }
  });
}

try {
  main();
} catch (err) {
  showError(err);
}
